import styled from 'styled-components';
import {FcInfo} from 'react-icons/fc';
import {GrView} from 'react-icons/gr';
export const DivPrincipal = styled.div`
    height:calc(100% - 60px);
    overflow:auto;
    justify-content:center;
    text-align:center;
    padding:20px;
    >form{
        flex-direction:unset!important;
        flex-wrap:wrap;
        justify-content:center;
        text-align:initial;
    }
    >div{
        display:flex;
        >div{
            flex:1;
            margin-left:10px;
            >img{
                width:230px;
                height:230px;
            }
        :nth-child(2){
            >p{
                margin: 10px 0;
                font-size:16px;
                font-weight:600;
            }
        }
    }}
    div>div>div>button{
                width:230px;
    }
    :first-child{
        margin:0 5px;
        text-align:initial;
    }
    @media(max-width:800px){
        padding:5px;
        height:calc(100% - 100px);
    }

`
export const DivHeader = styled.div`
    display:flex;
    width:inherit;
    flex-wrap:nowrap;
    margin:0 10px;
    :first-child{
        >div:nth-child(1){
            margin-right:20px;
            width:auto;
        }
    }
    @media(max-width:715px){
        flex-wrap:wrap;
        width:100%;
        :first-child{
            >div{
                margin:auto!important;
            }
            >img{
                width:100%
            }
        }
        div:nth-child(2){
            margin:0;
        }
    }

`

export const DivInput = styled.div`
    margin:10px;
    width: 45vw;
    min-width:350px;
    flex:auto;
    >p{
        margin:10px 5px;
        font-weight:bolder;
        font-size:16px;
    }
    >input{
        min-width:350px;
        min-height:40px;
        font-family:inherit;
        background:#fff;
    }
    >textarea{
        min-height:150px;
        resize:none;
        width:inherit;
        border: 0px solid #fff;
        padding: 10px;
        border-radius:5px;
        font-family: inherit;
        font-weight: 500;
        font-size:16px;
        :focus {
        border: 1px solid #99d2ff;
        box-shadow: 0px 0px 3px 0px #99d2ff;
        }

        ::placeholder{
        font-weight:400;
        }
    }
    @media(max-width:800px){
        max-width:100vw;
        overflow:hidden;
        min-width:unset;
        width:fit-content;
    }

`
export const ButtonHide = styled.button`
    border:1px solid #333333;
    background-color:#333333;
    border-radius:5px;
    padding:5px;
    cursor:pointer;
    width: 200px;
    height:40px;
    justify-content: center;
    align-items: center;
    display: ${props=>props.display?props.display:'none'}; /* Hidden by default */
    position: fixed; /* Fixed/sticky position */
    bottom: 20px; /* Place the button at the bottom of the page */
    right: 30px; /* Place the button 30px from the right */
    z-index: 3; /* Make sure it does not overlap */
    outline: none; /* Remove outline */

    :active {
        box-shadow: inset 0 0 2px rgba(128, 128, 128, 0.1);
        transform: translateY(2px);
    }

    @media(max-width:800px){
        width:auto;
        height:40px;
        right:20px;
        max-width:160px;
        bottom:10px;
    }

`
export const TituloConfiguracao = styled.p`
    font-size:20px;
    display:flex;
    align-items:center;
`
export const DivTituloConfiguracao = styled.div`
    width:100%;
    border-bottom:1px solid black;
    text-align:center;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0;
`

export const DivImgEButton = styled.div`
text-align:center;
display:flex;
flex-direction:column;
align-items:center;


`
export const DivImgLogoPerfil = styled.img`

max-width:1200px;
max-height:300px;
margin-bottom:10px;

@media(max-width:800px){
    max-width:100vw;

}

`
export const InstrucaoParaImagem = styled.div`
    max-width:90vw;
    text-align:center;

`
export const ImgPaginasBlog = styled.img`
    max-width:1900px;
    max-height:300px;
    margin-bottom:10px;
    @media(max-width:800px){
        max-width:100vw;
    }
`
export const ImgLogo = styled.img`
    max-width:1180px;
    width:fit-content;
    height:fit-content;
    max-height:200px;
    margin:0 0 20px 0;
    @media(max-width:800px){
        max-width:100vw;
    }
`
export const ImgLogoMobile = styled.img`

    max-width:240px;
    max-height:70px;
    width:fit-content;
    height:fit-content;
    margin: 0 0 20px 0;
    @media(max-width:800px){
        max-width:100vw
    }

`
export const IconFcInfo = styled(FcInfo)`
    font-size:inherit;
    margin: 0 0 0 10px;
`
export const IconGrView = styled(GrView)`
    font-size:inherit;
    margin:0 0 0 10px;
    display:inherit;
`
